
<div>
  <div class="tab-wrapper" :class="{ 'active-tab': isActive, 'no-hover': noHover, untitled }" @click="$emit('click')">
    <n-icon v-if="iconLeft" size="s" :icon="iconLeft" class="icon-left" />
    <n-icon size="s" icon="plus" class="plus-icon" v-if="showAdd" />
    {{ titleOrPlaceholder }}
    <n-icon v-if="iconRight" size="s" :icon="iconRight" class="icon-right" />
  </div>
</div>
